import { render, staticRenderFns } from "./ScenicJingquKoubeiZhishu.vue?vue&type=template&id=038c185f&scoped=true&"
import script from "./ScenicJingquKoubeiZhishu.vue?vue&type=script&lang=js&"
export * from "./ScenicJingquKoubeiZhishu.vue?vue&type=script&lang=js&"
import style0 from "./ScenicJingquKoubeiZhishu.vue?vue&type=style&index=0&id=038c185f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c185f",
  null
  
)

export default component.exports